<template>
  <div v-if="reportingEnabled">
    <b-button variant="primary" @click="showModal = true" class="mb-3">
      {{ $t('diary.add') }}
    </b-button>

    <b-modal
      ref="diaryModal"
      :visible="showModal"
      size="xl"
      scrollable
      hide-footer
      :title="$t('diary.add')"
      @hidden="onModalHidden"
      @close="onModalHidden"
    >
      <order-intake-forms
        v-if="showModal"
        elementId="diary-report-iframe"
        :form="form_id"
        :locale="locale"
        :opportunitySfid="job.opportunity.sfid"
        :orderApiId="job.job.api_id"
        :accessToken="access_token"
        @submit="onReportSubmitted"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OrderIntakeForms from '@gid/vue-common/components/OrderIntakeForms';
import { JobStatusEnum } from '@gid/models';

export default {
  components: {
    OrderIntakeForms,
  },
  props: {
    job: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    ...mapGetters(['locale', 'access_token']),
    form_id() {
      return this.job.opportunity.multiday_documentation_form_id;
    },
    reportingEnabled() {
      return this.form_id;
    },
  },
  methods: {
    onModalHidden() {
      this.showModal = false;
    },
    onReportSubmitted() {
      this.showModal = false;
      this.$emit('report-submitted');
    },
  },
};
</script>

<style lang="scss" scoped>
// Add any custom styles here if needed
</style>
